import React, { useState, useEffect, useRef } from "react";
import Logo from "../../Assets/images/clientpage/slt.jpg";
import Logo2 from "../../Assets/images/clientpage/ChatWithUsPic.jpg";
import { connect } from "react-redux";
import "../../Assets/style/components/assets-chat.css";
import axios from "axios";
import {
  Box,
  Stack,
  Avatar,
  Typography,
  Button,
  IconButton,
  Tooltip,
  InputAdornment,
  Popover,
  styled,
  TextField,
} from "@mui/material";
import CryptoJS from "crypto-js";
import { ToastContainer, toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import io from "socket.io-client";
import moment from "moment";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import {
  BaseUrl,
  newBaseUrlLang,
  SocketUrl,
} from "../../Container/BaseUrl/BaseUrl";
import {
  ArrowCircleDown,
  ChatsCircle,
  DotsThreeOutline,
  PaperPlaneTilt,
  Prohibit,
  VideoCamera,
} from "@phosphor-icons/react";
export const toaststyle = {
  position: "bottom-left",
  autoClose: 1000,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
  progress: undefined,
  theme: "light",
};
import { MdAttachFile } from "react-icons/md";
import { FiSmile } from "react-icons/fi";
const Theam = "#1bb80f";
const TheamLight = "#1bb80f96";
import {
  setshowChatForm,
  setshowForm,
  setChatData,
  setAgentLeft,
  setChatType,
} from "../../Redux/Actions/actions";
import PreViewmodal from "../chat-components/Chat-component/chat-component-model/PreViewmodal";
import {
  AudioMsg,
  BotChat,
  DocMsg,
  ImageMsg,
  TextMsg,
  Timeline,
  VideoMsg,
} from "./MsgTypes";
const mapStateToProps = (state) => {
  return {
    showChatForm: state.customerPortal.showChatForm,
    showform: state.customerPortal.showform,
    chatData: state.customerPortal.chatData,
    agentLeft: state.customerPortal.agentLeft,
    chatType: state.customerPortal.chatType,
  };
};

export const StyledInput = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    maxHeight: 200,
    padding: "10px",
    borderRadius: "20px",
    lineHeight: "14px !important",
    overflowX: "scroll !important",
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
    "&::-webkit-scrollbar": {
      width: "0",
    },
  },
  "& .MuiInputBase-root": {
    padding: "7px 0px",
    borderRadius: "16px",
  },
}));
let socket = null;
const CustomerPortal = (props) => {
  const scrollRef = useRef(null);
  const endOfMessagesRef = useRef(null);
  const inputRef = useRef(null);
  const [values, setValues] = useState({
    username: "",
    phonenumber: "",
    email: "",
    skillset: "",
    language: "",
    complaint: "",
    availableAgent: "agent",
  });
  const [skilldropdown, setSkilldropdown] = useState([]);
  const [languagedropdown, setLanguagedropdown] = useState([]);
  const [uploadedFile, setuploadedFile] = useState();
  const [showPreviewmodal, setshowPreviewmodal] = useState(false);
  const [customerSpinner, setCustomerSpinner] = useState(false);
  const [customerSpinnerVideo, setCustomerSpinnerVideo] = useState(false);
  const [AgentTyping, setAgentTyping] = useState(false);
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [messages, setMessages] = useState([]);
  const [cursorPosition, setcursorPosition] = useState();
  const [followerlink, setFollowerlink] = useState("");
  const [count, setcount] = useState(0);
  const [msg, setMsg] = useState("");
  const [activeAgent, setactiveAgent] = useState("");

  // emoji popup dialog box variables and open and close function
  const [anchorEl, setAnchorEl] = useState(null);
  let open = Boolean(anchorEl);
  let id = open ? "simple-popover" : undefined;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [chatendAnchorEl, setchatendAnchorEl] = useState(null);
  let ChatEndopen = Boolean(chatendAnchorEl);
  let chatEndid = ChatEndopen ? "simple-popover" : undefined;
  const ChatEndhandleClick = (event) => {
    setchatendAnchorEl(event.currentTarget);
  };
  const ChatEndhandleClose = () => {
    setchatendAnchorEl(null);
  };

  // emoji functionaly
  const onEmojiClick = (e) => {
    let ref = inputRef.current.children[0].children[1];
    ref.focus();
    let start = msg.substring(0, ref.selectionStart);
    let end = msg.substring(ref.selectionStart);
    let text = start + e.native + end;
    setMsg(text);
    setcursorPosition(start.length + e.emoji);
    handleClose();
  };
  // this functionaly use to place emoji on current cursor position
  useEffect(() => {
    if (!props.showChatForm) {
      if (inputRef.current) {
        inputRef.current.children[0].children[1].selectionEnd = cursorPosition;
      }
    }
  }, [cursorPosition]);

  // skillset dropdown list
  const skillsetDropdown = () => {
    axios
      .post(
        newBaseUrlLang + "usermodule/clientMaster/skills/list",
        {
          enabled: true,
        },
        {
          headers: {
            tenantId: localStorage.getItem("tenantid"),
          },
        }
      )
      .then((res) => {
        if (res.data.status == "OK") {
          setSkilldropdown(res.data.dataList);
        } else {
          setSkilldropdown([]);
        }
      })
      .catch((error) => {
        toast.warn("Server is down,please try after some time", toaststyle);
      });
  };
  // language dropdown list
  const languageDropdownList = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/languages/list", data, {
        headers: {
          tenantId: localStorage.getItem("tenantid"),
        },
      })
      .then((res) => {
        if (res.data.status == "OK") {
          setLanguagedropdown(res.data.dataList);
        } else {
          setLanguagedropdown([]);
        }
      })
      .catch((error) => {
        toast.warn("Server is down,please try after some time", toaststyle);
      });
  };
  useEffect(() => {
    let tenantID = window.location.search;
    const urlParams = new URLSearchParams(tenantID);
    const param1 = urlParams.get("tenantID");
    localStorage.setItem("tenantid", param1);
    // language dropdown list API call
    languageDropdownList();
  }, []);

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };
  // validate form
  const validateForm = () => {
    const { username, phonenumber, email, language } = values;
    if (username === "") {
      toast.error("username is required.", toaststyle);
      return false;
    } else if (email === "") {
      toast.error("email is required.", toaststyle);
      return false;
    } else if (phonenumber === "") {
      toast.error("phonenumber is required.", toaststyle);
      return false;
    } else if (language === "") {
      toast.error("language is required.", toaststyle);
      return false;
    }
    return true;
  };
  const createSession = async (Type) => {
    if (validateForm()) {
      const { username, phonenumber, email, skillset, language, complaint } =
        values;
      let datas = {};
      if (Type === "chat") {
        setCustomerSpinner(true);
        datas = {
          name: username,
          email_id: email,
          phone: phonenumber,
          channel: "webchat",
          latitude: "23°27N",
          longitute: "23.5",
          skillset: "AGMC_Test",
          language: language,
          complaint: "",
        };
      } else if (Type === "video") {
        setCustomerSpinnerVideo(true);
        datas = {
          name: username,
          email_id: email,
          phone: phonenumber,
          channel: "videochat",
          latitude: "23°27N",
          longitute: "23.5",
          skillset: "WC_Slt",
          language: language,
          complaint: "",
        };
      }
      await axios
        .post(BaseUrl + "/users/createsession", datas, {
          headers: {
            tenantId: localStorage.getItem("tenantid"),
          },
        })
        .then((res) => {
          // console.log("session created", res);
          if (res.data.status == true) {
            localStorage.setItem("chatData", JSON.stringify(res.data.data[0]));
            setCustomerSpinner(false);
            setCustomerSpinnerVideo(false);
            if (res.data.data[0].channel == "videochat") {
              localStorage.setItem(
                "videoChatLink",
                res.data.data[0].follower_link
              );
              setFollowerlink(res.data.data[0].follower_link);
              props.setChatType("Video");
            } else {
              props.setChatType("Text");
            }
            setTimeout(() => {
              setData();
            }, 2000);
            props.setshowForm(false);
          } else {
            setCustomerSpinner(false);
            setCustomerSpinnerVideo(false);
            toast.error(
              "Something went wrong while creating session with agent",
              toaststyle
            );
          }
        })
        .catch((err) => {
          setCustomerSpinner(false);
          setCustomerSpinnerVideo(false);
          // console.log("Create chat session", err);
        });
    }
  };

  const setData = async () => {
    var emaildata = JSON.parse(localStorage.getItem("chatData"));
    if (!emaildata) return;
    await axios
      .post(
        BaseUrl + `/users/getId/${emaildata.email}`,
        {},
        {
          headers: {
            tenantId: localStorage.getItem("tenantid"),
          },
        }
      )
      .then((res) => {
        axios
          .post(
            BaseUrl + "/message/getCurrentChatMessage",
            {
              sessionId: res.data.user.chat_session_id,
            },
            {
              headers: {
                tenantId: localStorage.getItem("tenantid"),
              },
            }
          )
          .then((res) => {
            if (res.data.data) {
              setMessages(res.data.data);
            } else {
              setMessages([]);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {});
    ConnectSocket();
    getData();
  };
  const getData = async () => {
    const chatData = JSON.parse(localStorage.getItem("chatData"));
    if (!chatData) return;
    await axios
      .post(BaseUrl + `/users/getClients/${chatData.id}`, {
        headers: {
          tenantId: localStorage.getItem("tenantid"),
        },
      })
      .then((res) => {
        let agentDetails = res.data.agents;
        setactiveAgent(agentDetails.username);
        localStorage.setItem(
          "Accepted_Agent",
          JSON.stringify({
            username: agentDetails.username,
            email: agentDetails.email,
            password: agentDetails.password,
            is_available: agentDetails.is_available,
            id: agentDetails.id,
          })
        );
      });
  };
  //socket functionally
  const ConnectSocket = () => {
    socket = io(SocketUrl + "/" + localStorage.getItem("tenantid"));
    const chat_User_id = JSON.parse(localStorage.getItem("chatData"));
    if (!chat_User_id) return;
    socket.on("connect", function () {
      socket.emit("add-user", chat_User_id.id);
      console.log("Chat socket Connected");
    });
    socket.on("update-client-recv", (msg) => {
      console.log("update-client-recv", msg);
      let chatData = JSON.parse(localStorage.getItem("chatData"));
      if (chatData.id === msg.id) {
        localStorage.removeItem("chatData");
        var arr = {
          id: msg.id,
          phonenumber: msg.phonenumber,
          username: msg.username,
          email: msg.email,
        };
        localStorage.setItem("chatData", JSON.stringify(arr));
      }
    });
    socket.on("msg-receive", (msg) => {
      // console.log("msg-receive", msg);
      if (msg.chatdetails.status == "chatEnded") {
        props.setAgentLeft(true);
      }
      setAgentTyping(false);
      setArrivalMessage({
        fromSelf: true,
        message: msg.msg,
        senderName: msg.senderName,
        msg_sent_type: msg.msg_sent_type,
        session_id: msg.session_id,
        file_name: msg.file_name,
        time: msg.time,
      });
    });
    socket.on("typing-msg-receive", (msg) => {
      // console.log("typing-msg-receive", msg);
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
      setAgentTyping(true);
    });
    socket.on("check-agent-recv", async (msg) => {
      // console.log("agent is accepted", msg);
      getData();
    });
  };

  const clearCache = () => {
    setactiveAgent("");
    props.setshowForm(true);
    props.setshowChatForm(true);
    props.setAgentLeft(false);
    localStorage.removeItem("chatData");
    localStorage.removeItem("Accepted_Agent");
    window.location.reload();
  };
  //end the chat
  const clearChat = async () => {
    try {
      let msg = "Customer Ended the Chat";
      let chatData = JSON.parse(localStorage.getItem("chatData"));
      let Agent = JSON.parse(localStorage.getItem("Accepted_Agent"));
      await socket.emit("customer-end-chat-req", {
        chat_session_id: chatData.chat_session_id,
      });
      await socket.emit("last-msg-send", {
        to: Agent.id,
        session_id: chatData.chat_session_id,
        from: chatData.id,
        chatType: "inbound",
        msg,
        senderName: chatData.username,
        chatdetails: chatData,
      });
      await socket.emit("send-msg", {
        to: Agent.id,
        from: chatData.id,
        chatType: "inbound",
        msg: msg,
        senderName: chatData.username,
        msgType: "web",
        msg_sent_type: "NOTIFICATIONS",
        session_id: chatData.chat_session_id,
        chatdetails: chatData,
        file_name: "",
      });
      await axios
        .post(
          BaseUrl + "/message/addMessage",
          {
            to: Agent.id,
            from: chatData.id,
            message: msg,
            senderName: chatData.username,
            messageFrom: "fromClient",
            msg_sent_type: "NOTIFICATIONS",
            session_id: chatData.chat_session_id,
            file_name: "",
          },
          {
            headers: {
              tenantId: localStorage.getItem("tenantid"),
            },
          }
        )
        .then((res) => {
          axios
            .post(
              BaseUrl + "/message/chatEndByCustomer",
              {
                chat_session_id: chatData.chat_session_id,
              },
              {
                headers: {
                  tenantId: localStorage.getItem("tenantid"),
                },
              }
            )
            .then((res) => {
              clearCache();
            })
            .catch((error) => {
              toast.warn(
                "Server is down, Please try after some time",
                toaststyle
              );
              clearCache();
            });
        })
        .catch((err) => {
          clearCache();
        });
    } catch (error) {
      clearCache();
    }
  };
  // emit typing socket event
  const handleTyping = async () => {
    const chatData = await JSON.parse(localStorage.getItem("chatData"));
    const Agent = await JSON.parse(localStorage.getItem("Accepted_Agent"));

    socket.emit("typing-send-msg", {
      to: Agent.id,
      from: chatData.id,
      senderName: chatData.username,
      chatType: "Inbound",
      chatdetails: chatData,
    });
  };
  // send message function
  const handleSendMsg = async (recivedMsg, mediaType, FileName) => {
    if ((event.key === "Enter" && !event.shiftKey) || event.type == "click") {
      event.preventDefault();
      try {
        const i = count + 1;
        setcount(i);
        let msg_type = mediaType;
        let msg = recivedMsg.trim();
        if (msg.length > 0) {
          const chatData = await JSON.parse(localStorage.getItem("chatData"));
          const Agent = JSON.parse(localStorage.getItem("Accepted_Agent"));
          socket.emit("last-msg-send", {
            to: Agent.id,
            from: chatData.id,
            session_id: chatData.chat_session_id,
            chatType: "inbound",
            msg: msg.trim(),
            senderName: chatData.username,
            chatdetails: chatData,
            msg_sent_type: msg_type,
            count: i,
            file_name: FileName,
          });
          socket.emit("send-msg", {
            to: Agent.id,
            from: chatData.id,
            chatType: "inbound",
            msg: msg.trim(),
            senderName: chatData.username,
            msgType: "web",
            msg_sent_type: msg_type,
            session_id: chatData.chat_session_id,
            chatdetails: chatData,
            file_name: FileName,
          });

          axios.post(
            BaseUrl + "/message/addMessage",
            {
              to: Agent.id,
              from: chatData.id,
              message: msg.trim(),
              senderName: chatData.username,
              messageFrom: "fromClient",
              msg_sent_type: msg_type,
              session_id: chatData.chat_session_id,
              file_name: FileName,
            },
            {
              headers: {
                tenantId: localStorage.getItem("tenantid"),
              },
            }
          );
          const msgs = [...messages];
          msgs.push({
            fromSelf: false,
            message: msg.trim(),
            senderName: chatData.username,
            msg_sent_type: msg_type,
            session_id: chatData.chat_session_id,
            file_name: FileName,
            time: moment().format("MMM DD, YYYY h:mm A"),
          });
          setMessages(msgs);
          setMsg("");
        }
      } catch (e) {
        // console.log("handleSendMsg", e);
        toast.error("Something Went Wrong", toaststyle);
      }
    }
  };

  useEffect(() => {
    if (!props.showform) {
      arrivalMessage && setMessages((prev) => [...prev, arrivalMessage]);
    }
  }, [arrivalMessage]);

  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  useEffect(() => {
    if (!props.showform) {
      setData();
    }
  }, []);

  const sendFile = () => {
    if (!uploadedFile) return toast.error("Something Went Wrong", toaststyle);
    handleSendMsg(
      uploadedFile.attachmentUrl,
      uploadedFile.fileType,
      uploadedFile.filename
    );
  };

  return (
    <>
      <ToastContainer transition={Flip} limit={1} />

      {/* form */}
      {props.showChatForm && (
        <Avatar
          src={Logo2}
          sx={{
            position: "fixed",
            bottom: "15px",
            right: "5px",
            width: "70px",
            height: "70px",
            color: "#FFFF",
            background: Theam,
            boxShadow: "12px 15px 20px 0 rgba(46, 61, 73, 0.15)",
            zIndex: 99999,
            borderRadius: "50%",
            cursor: "pointer",
            margin: "15px",
          }}
          onClick={() => {
            props.setshowChatForm(false);
          }}
        />
      )}
      {/* chat */}
      {!props.showChatForm && (
        <Box
          className="chatbox-popup"
          sx={{
            position: "fixed",
            zIndex: 9,
            boxShadow: "5px 5px 25px 0 rgba(46, 61, 73, 0.2)",
            bottom: "30px",
            right: "15px",
            width: "350px",
            height: "530px",
            borderRadius: "10px",
            background: "#FFFF",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <header
            className="d-flex justify-content-between align-items-center"
            style={{
              width: "100%",
              padding: "5px 15px",
              height: "40px",
              background: Theam,
              alignItems: "center",
              justifyContent: "space-around",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            {!props.showform && (
              <>
                <IconButton
                  aria-describedby={chatEndid}
                  onClick={ChatEndhandleClick}
                >
                  <DotsThreeOutline size={18} weight="fill" color="#FFFF" />
                </IconButton>

                <Popover
                  id={chatEndid}
                  open={ChatEndopen}
                  anchorEl={chatendAnchorEl}
                  onClose={ChatEndhandleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      color: "white",
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: "7px",
                        left: "5px",
                        width: 20,
                        height: 20,
                        background: "white",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                >
                  <Button
                    onClick={clearChat}
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      border: "none",
                      "&:hover": { border: "none" },
                    }}
                    startIcon={<Prohibit size={18} weight="fill" />}
                  >
                    End Chat
                  </Button>
                </Popover>
              </>
            )}
            <Typography
              variant="caption"
              sx={{ color: "white", fontWeight: 600 }}
            >
              Welcome to Inaipi!
            </Typography>

            <Button
              endIcon={
                <ArrowCircleDown size={13} color="white" weight="fill" />
              }
              sx={{
                background: "#1976D2",
                color: "white",
                fontWeight: 600,
                padding: "6px 6px",
                borderRadius: "10px",
                fontSize: "8px",
                ":hover": {
                  background: "#1976D2",
                },
              }}
              onClick={() => {
                props.setshowChatForm(true);
              }}
            >
              Close
            </Button>
          </header>
          {!props.showform && (
            <>
              {activeAgent && (
                <header
                  className="d-flex align-items-center"
                  style={{
                    width: "100%",
                    padding: "5px 10px",
                    height: "60px",
                    background: TheamLight,
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Avatar src={Logo} />
                  <Stack>
                    <Typography
                      variant="caption"
                      sx={{ color: "white", fontWeight: 600 }}
                    >
                      Agent ( {activeAgent} ) joined a chat
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "white", fontWeight: 600 }}
                    >
                      {props.agentLeft ? "Offline" : "Online"}
                    </Typography>
                  </Stack>
                </header>
              )}
            </>
          )}
          {props.showform && (
            <main
              style={{
                height: "calc(100% - 40px)",
                padding: "20px 20px",
                flexGrow: 1,
                overflowY: "scroll",
              }}
            >
              <form>
                <div className="mb-3 d-flex align-items-start flex-column">
                  <label className="input_label mb-2" for="email_field">
                    Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Enter Username"
                    name="username"
                    required="true"
                    onChange={(e) => handleChange(e)}
                  ></input>
                </div>
                <div className="mb-3 d-flex align-items-start flex-column">
                  <label className="input_label mb-2" for="email_field">
                    Email
                  </label>

                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    id="exampleFormControlInput2"
                    placeholder="Enter Email"
                    onChange={(e) => handleChange(e)}
                    required
                  ></input>
                </div>
                <div className="mb-3 d-flex align-items-start flex-column">
                  <label className="input_label mb-2" for="email_field">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phonenumber"
                    className="form-control"
                    required
                    pattern="[0-9]*"
                    maxLength={15}
                    id="exampleFormControlInput3"
                    placeholder="Enter Phone number"
                    onChange={(e) => handleChange(e)}
                  ></input>
                </div>
                <div className="mb-3 d-flex align-items-start flex-column">
                  <label className="input_label mb-2" for="email_field">
                    Select Language
                  </label>
                  <select
                    className="form-select"
                    name="language"
                    required
                    aria-label="Default select example"
                    onChange={(e) => handleChange(e)}
                    id="select_language"
                  >
                    <option value="" selected disabled>
                      Select Language
                    </option>

                    {languagedropdown.length > 0 ? (
                      languagedropdown.map((item, index) => {
                        return (
                          <option
                            key={index}
                            id={item.languageId}
                            value={item.languageDesc}
                          >
                            {item.languageDesc}
                          </option>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </select>
                </div>
                <div className="mb-3 d-flex align-items-start flex-column">
                  <label className="input_label mb-2" for="email_field">
                    Skillset
                  </label>
                  <select
                    className="form-select"
                    name="skillset"
                    required
                    disabled
                    aria-label="Default select example"
                    onChange={(e) => handleChange(e)}
                    id="select_language"
                  >
                    <option value="" selected disabled>
                      select Skillset
                    </option>

                    {skilldropdown.length > 0 ? (
                      skilldropdown.map((item, index) => {
                        return (
                          <option
                            key={index}
                            id={item.languageId}
                            value={item.languageDesc}
                          >
                            {item.languageDesc}
                          </option>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </select>
                </div>
              </form>
            </main>
          )}
          {!props.showform && (
            <div
              ref={scrollRef}
              style={{
                height: "calc(100% - (40px + 60px))",
                padding: "10px 15px",
                flexGrow: 1,
                overflowY: "scroll",
                overflowX: "none",
                scrollBehavior: "smooth",
              }}
            >
              {props.chatType == "Text" ? (
                <>
                  {messages.length > 0 ? (
                    <>
                      {messages.map((el, index) => {
                        const messageStyle = {
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "end",
                          alignItems: "flex-end",
                        };
                        switch (el.msg_sent_type) {
                          case "NOTIFICATIONS":
                            return <Timeline el={el} key={index} />;
                          case "jpeg":
                          case "png":
                          case "IMAGE":
                          case "APPLICATION":
                            return (
                              <ImageMsg el={el} menu={false} key={index} />
                            );
                          case "vnd.openxmlformats-officedocument.wordprocessingml.document":
                            return (
                              <DocMsg
                                el={el}
                                menu={false}
                                key={index}
                                type={"docx"}
                                size={"200px"}
                                onClick={() => window.open(el.signedUrl, '_blank')}
                              />
                            );
                          case "pdf":
                            return (
                              <DocMsg
                                el={el}
                                menu={false}
                                key={index}
                                type={"pdf"}
                                size={"200px"}
                              />
                            );
                          case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                            return (
                              <DocMsg
                                el={el}
                                menu={false}
                                key={index}
                                type={"xlsx"}
                                size={"200px"}
                              />
                            );

                          case "msword":
                            return (
                              <DocMsg
                                el={el}
                                menu={false}
                                key={index}
                                type={"plain"}
                                size={"200px"}
                              />
                            );
                          case "plain":
                            return (
                              <DocMsg
                                el={el}
                                menu={false}
                                key={index}
                                type={"plain"}
                                size={"200px"}
                              />
                            );
                          case "AUDIO":
                            return (
                              <AudioMsg
                                el={el}
                                menu={false}
                                key={index}
                                style={messageStyle}
                              />
                            );
                          case "wav":
                            return (
                              <AudioMsg
                              className='wavclass'
                              el={el}
                              menu={false}
                              key={index}
                            
                            />
                            );

                          case "mpeg":
                            return (
                              <AudioMsg el={el} menu={false} key={index} />
                            );
                          case "mp4":
                          case "VIDEO":
                            return (
                              <VideoMsg el={el} menu={false} key={index} />
                            );

                          case "webm":
                            return (
                              <VideoMsg el={el} menu={false} key={index} />
                            );

                          default:
                            return (
                              <TextMsg
                                el={el}
                                menu={false}
                                key={index}
                                size={"300px"}
                              />
                            );
                        }
                      })}
                      <div ref={endOfMessagesRef} />
                    </>
                  ) : (
                    <></>
                  )}
                  {AgentTyping && <BotChat Theam={Theam} />}
                </>
              ) : (
                <>
                  <iframe
                    src={localStorage.getItem("videoChatLink")}
                    title="My iframe"
                    width="330"
                    height="350"
                    frameBorder="0"
                    allow="camera; microphone"
                  ></iframe>
                </>
              )}
            </div>
          )}
          <footer
            className="d-flex align-items-center"
            style={{
              width: "100%",
              padding: "5px",
              justifyContent: "space-around",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              height: "60px",
              gap: "5px",
              // boxShadow: "rgb(180 180 180 / 48%) 0px -3px 7px -1px",
            }}
          >
            {/* initiate chat button*/}
            {props.showform && (
              <>
                <Stack
                  sx={{ width: "100%" }}
                  direction={"row"}
                  alignItems={"flex-end"}
                  justifyContent={"flex-end"}
                  spacing={1}
                >
                  <Button
                    startIcon={
                      <VideoCamera size={18} color="white" weight="fill" />
                    }
                    disabled={customerSpinnerVideo}
                    sx={{
                      background: Theam,
                      color: "white",
                      fontWeight: 600,
                      padding: "6px 10px",
                      borderRadius: "10px",
                      fontSize: "12px",
                      ":hover": {
                        background: TheamLight,
                      },
                    }}
                    onClick={() => createSession("video")}
                  >
                    Video Chat
                  </Button>

                  <Button
                    startIcon={
                      <PaperPlaneTilt size={18} color="white" weight="fill" />
                    }
                    disabled={customerSpinner}
                    sx={{
                      background: Theam,
                      color: "white",
                      fontWeight: 600,
                      padding: "6px 10px",
                      fontFamily: "sans-serif",
                      borderRadius: "10px",
                      fontSize: "12px",
                      ":hover": {
                        background: TheamLight,
                      },
                    }}
                    onClick={() => createSession("chat")}
                  >
                    Chat Now
                  </Button>
                </Stack>
              </>
            )}

            {!props.showform &&
              !props.agentLeft &&
              props.chatType == "Text" && (
                <>
                  <StyledInput
                    fullWidth
                    placeholder="Type a message"
                    value={msg}
                    onChange={(e) => {
                      inputRef.current.children[0].children[1].scrollTop =
                        inputRef.current.children[0].children[1].scrollHeight;
                      setMsg(e.target.value);
                      handleTyping();
                    }}
                    ref={inputRef}
                    onKeyDown={() => {
                      handleSendMsg(msg, "TEXT", "text");
                    }}
                    variant="filled"
                    InputProps={{
                      disableUnderline: true,
                      startAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="smile"
                            size="small"
                            aria-describedby={id}
                            onClick={(e) => {
                              handleClick(e);
                            }}
                          >
                            <FiSmile />
                          </IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            className="me-1"
                            onClick={() => {
                              setshowPreviewmodal(true);
                            }}
                          >
                            <MdAttachFile />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    onClick={() => {
                      handleSendMsg(msg, "TEXT", "text");
                    }}
                    variant="contained"
                    sx={{
                      height: "45px",
                      padding: "5px 15px",
                      minWidth: "35px",
                    }}
                  >
                    <PaperPlaneTilt size={18} color="white" weight="fill" />
                  </Button>
                </>
              )}
          </footer>
        </Box>
      )}
      {showPreviewmodal && (
        <PreViewmodal
          showPreviewmodal={showPreviewmodal}
          uploadedFile={uploadedFile}
          sendMessage={sendFile}
          UploadFrom={"customerPortal"}
          setuploadedFile={setuploadedFile}
          handleClose={() => {
            setshowPreviewmodal(false);
            setuploadedFile(null);
          }}
        />
      )}
      <Popover
        sx={{
          zIndex: 99999,
          top: "-14px",
          left: "-10px",
          "& .MuiPaper-root": {
            borderRadius: "13px",
            height: "310px",
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
              width: "0",
            },
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Picker
          data={data}
          onEmojiSelect={onEmojiClick}
          theme={"light"}
          perLine={8}
        />
      </Popover>
    </>
  );
};

export default connect(mapStateToProps, {
  setshowChatForm,
  setshowForm,
  setChatData,
  setAgentLeft,
  setChatType,
})(CustomerPortal);
